import { createBrowserRouter } from "react-router-dom";

import { Auth, Authorize, Choices, Dashboard, Merchant, Needs } from "../views";
import VoucherRedemption from "../views/merchant/pages/voucher_redemption";
import AccessDisabled from "../views/access_disabled/access_disabled";
import AddNewAdmin from "../views/admins/components/add_new_admin/add_new_admin";
import UserManagement from "../views/admins/user_management/user_management";
import Analytics from "../views/analytics/analytics";
import Enquiries from "../views/schemes/enquiries/enquiries_list";
import NeedDetails from "../views/needs/details/details";
import NotFound from "../views/not_found/not_found";
import Settings from "../views/settings/settings";
import SurveyUI from "../views/survey-ui/survey-ui";
import AddNewSchemes from "../views/schemes/add_new_scheme/add_new_scheme";
import EnquiryDetails from "../views/schemes/enquiry_details/enquiry_details";
import FamilyEnquiries from "../views/schemes/family_enquiries/family_enquiry_list";
import FamilyEnquiryDetails from "../views/schemes/family_enquiry_details/family_enquiry_details";
import ModifyAdminDetails from "../views/admins/user_management/modify_user_details/modify_user_details";
import ModifyRolePermissions from "../views/admins/role_management/modify_role_permissions/modify_role_permissions";
import Schemes from "../views/schemes/schemes/schemes";
import EditScheme from "../views/schemes/edit_scheme/edit_scheme";
import Reports from "../views/reports/reports";
import ChoicesResponse from "../views/choices/choices_response/choices_response";
import Services from "../views/services/services";
import ServiceDetails from "../views/services/service_details/service_details";
import Jobs from "../views/jobs/jobs";
import JobDetails from "../views/jobs/job_details";
import JobApplicationDetails from "../views/jobs/job_application_details/job_application_details";
import AddEditJob from "../views/jobs/add_edit_job/add_edit_job";
import CreateNewChoices from "../views/choices/create_new_choices/create_new_choices";
import ViewChoices from "../views/choices/edit_choice/view_choice";
import ResponseDetailPage from "../views/choices/response_detail_page/response_detail_page";
import FamilyResponseDetails from "../views/choices/family_response_details/family_response_Details";
import Surveyor from "../views/surveyor/surveyor";
import CreateNewSurveyor from "../views/surveyor/create_surveyor/create_new_surveyor";
import ViewSurveyor from "../views/surveyor/view_surveyor/view_surveyor";
import SubmittedResponseDetails from "../views/surveyor/submitted_response_Details/submitted_response_details";
import SurveyorChoiceResponseList from "../views/surveyor/components/surveyor_response_list/surveyor_response_list";
import Users from "../views/users/users";
import UserDetails from "../views/users/usersDetails/userDetails";
import Rewards from "../views/rewards/rewards";
import RewardsDetails from "../views/rewards/rewards_details/rewards_details";
import RedemptionRequestDetails from "../views/rewards/redemption_request_details/redemption_request_details";
import PrivateRoute from "./private_route";
import FileUpload from "../views/file_upload/file_upload";
import { add_new_client, add_roles, client_details, client_mapping, create_user, file_uploads, manage_roles_and_access, modify_client, modify_role, modify_user, view_role } from "./routes_path";
import CreateUser from "../views/users/create_user/create_user";
import ModifyUser from "../views/users/modify_user/modify_user";
import ClientMapping from "../views/client_mapping/client_mapping/user_management";
import ClientDetails from "../views/client_mapping/components/client_details/client_details";
import RoleManagement from "../views/client_mapping/role_management/role_management";
import AddNewClient from "../views/client_mapping/components/add_new_admin/add_new_client";
import AddAdminRole from "../views/client_mapping/components/add_admin_role/add_admin_role";
import ModifyClient from "../views/client_mapping/components/modify_client/modify_client";
import Loading from "../views/loading/loading";
import Notifications from "../views/notification/notification";
import { AddNotification } from "../views/notification/components/add-notifications";
import LandingPage from "../views/landing_page/landing_page";
import { AddLandingPage } from "../views/landing_page/components/add-landing-page";
import { EditLandingPage } from "../views/landing_page/components/edit-landing-page";
import VoiceRecording from "../views/voice_recording/voice_recording";
import Rules from "../views/rules/rules";
import { AddRule } from "../views/rules/components/add-rule";
import FmPortal from "../views/fm_portal/fm_portal";
import HourlyReport from "../views/fm_portal/hourly_report";
import HourlyReportDetails from "../views/fm_portal/hourly_report_details";
import HourlyReportResult from "../views/fm_portal/hourly_report_result";
import ChoiceQuestions from "../views/choices/components/choices-auto-notification/choice_questions";
import SurveyNotificationLogs from "../views/choices/components/choices-auto-notification/auto_notification_logs";
import NewsPage from "../views/cms/news/news";
import AddEditNews from "../views/cms/news/add_edit_news";
import BannersPage from "../views/cms/banners/banners";
import AddEditBanner from "../views/cms/banners/add_edit_banner";
import MediaLibrary from "../views/cms/media/media_library";
import AmiForYouPage from "../views/cms/amiforyou/amiforyou";
import AddEditAmiForYou from "../views/cms/amiforyou/add_edit_amiforyou";
import AppPollingPage from "../views/cms/app_polling/app_polling";
import AddEditAppPolling from "../views/cms/app_polling/add_edit_app_polling";
import HospitalsPage from "../views/hospitals/hospitals";
import AddEditHospital from "../views/hospitals/add_edit_hospital";
import HospitalSchemesPage from "../views/hospitals/hospital_schemes/hospital_schemes";
import HospitalFacilitiesPage from "../views/hospitals/hospital_facilities/hospital_facilities";
import HospitalSpecialitiesPage from "../views/hospitals/hospital_specialities/hospital_specialities";
import OrganizationsPage from "../views/organizations/organizations";
import AddEditOrganization from "../views/organizations/add_edit_organization";
import { cms_add_amiforyou, cms_add_app_polling, cms_add_banner, cms_add_news, cms_amiforyou, cms_app_polling, cms_banners, cms_edit_amiforyou, cms_edit_app_polling, cms_edit_banner, cms_edit_news, cms_media, cms_news, cms_view_amiforyou, cms_view_app_polling, cms_view_banner, cms_view_news, hospitals, hospitals_add, hospitals_edit, hospitals_view, hospital_schemes, hospital_facilities, hospital_specialities, organizations, organizations_add, organizations_edit } from "./routes_path";
export const routes = [
  {
    path: "/",
    element: <Auth />,
    title: "Auth",
  },
  {
    path: "/authorize",
    element: <Authorize />,
    title: "Authorize",
  },
  {
    path: "/dashboard",
    element: <PrivateRoute module='dashboard' path="/dashboard" element={<Dashboard />} />,
    title: "",
  },

  {
    path: "/reports",
    element: <PrivateRoute module='reports' platformOnly path="/reports" element={<Reports />} />,
    title: "",
  },
  {
    path: "/fm-portal",
    element: <PrivateRoute module='reports' path="/fm-portal" element={<FmPortal />} />,
    title: "FM Portal",
  },
  {
    path: "/fm-portal/hourly-report",
    element: <PrivateRoute module='reports' path="/fm-portal/hourly-report" element={<HourlyReport />} />,
    title: "Hourly Report",
  },
  {
    path: "/fm-portal/hourly-report/details",
    element: <PrivateRoute module='reports' path="/fm-portal/hourly-report/details" element={<HourlyReportDetails />} />,
    title: "Hourly Report Details",
  },
  {
    path: "/fm-portal/hourly-report/result",
    element: <PrivateRoute module='reports' path="/fm-portal/hourly-report/result" element={<HourlyReportResult />} />,
    title: "Hourly Report Result",
  },
  {
    path: "/needs",
    element: <PrivateRoute module='needs' path="/needs" element={<Needs />} />,
    title: "Needs",
  },
  {
    path: "/needs/:id",
    element: <PrivateRoute module='needs' path="/needs" element={<NeedDetails />} />,
    title: "Need Details",
  },
  {
    path: "/admins",
    element: <PrivateRoute module='reports' path="/reports" element={<UserManagement />} />,
    title: "User Management",
  },
  {
    path: "/admins/addNewAdmin",
    element: <PrivateRoute module='reports' path="/reports" element={<AddNewAdmin />} />,
    title: "Add New Admin",
  },
  {
    path: "/admins/modifyAdminDetails",
    element: <PrivateRoute module='reports' path="/reports" element={<ModifyAdminDetails />} />,
    title: "Modify Admin details",
  },
  {
    path: "/admins/manageRolesAndAccess",
    element: <PrivateRoute module='reports' path="/reports" element={<RoleManagement />} />,
    title: "Manage Roles And Access",
  },
  {
    path: "/admins/manageRolesAndAccess/modifyRole",
    element: <PrivateRoute module='reports' path="/reports" element={<ModifyRolePermissions viewOnly={false} />} />,
    title: "Modify Admin Role",
  },
  {
    path: "/admins/manageRolesAndAccess/viewRoleDetails",
    element: <PrivateRoute module='reports' path="/reports" element={<ModifyRolePermissions viewOnly={true} />} />,
    title: "Modify Admin Role",
  },
  {
    path: "*",
    element: <NotFound />,
    title: "NotFound",
  },
  {
    path: "/schemes/add",
    element: <PrivateRoute module='schemes' path="/schemes" element={<AddNewSchemes />} />,
    title: "Add New Scheme",
  },
  {
    path: "/analytics",
    element: <PrivateRoute module='reports' path="/reports" element={<Analytics />} />,
    title: "Analytics",
  },
  {
    path: "/surveys",
    element: <PrivateRoute module='choices' path="/surveys" element={<Choices />} />,
    title: "Surveys",
  },
  {
    path: "/surveys/questions/:id",
    element: <PrivateRoute module='choices' path="/surveys" element={<ChoiceQuestions />} />,
    title: "Surveys",
  },
  {
    path: "/surveys/notification-logs/:eventId",
    element: <PrivateRoute module='choices' path="/surveys" element={<SurveyNotificationLogs />} />,
    title: "Surveys",
  },
  {
    path: "/surveys/viewSurvey/:id",
    element: <PrivateRoute module='choices' path="/surveys" element={<ChoicesResponse />} />,
    title: "Surveys",
  },
  {
    path: "/settings",
    element: <PrivateRoute module='reports' path="/reports" element={<Settings />} />,
    title: "Settings",
  },
  {
    path: "/access-disabled",
    element: <PrivateRoute module='access-disabled' path="/access-disabled" element={<AccessDisabled />} />,
    title: "Settings",
  },
  {
    path: "/survey-ui/:id",
    element: <PrivateRoute module='choices' path="/survey-ui/:id" element={<SurveyUI />} />,
    title: "Settings",
  },
  {
    path: "/schemes",
    element: <PrivateRoute module='schemes' path="/schemes" element={<Schemes />} />,
    title: "Schemes",
  },
  {
    path: "/schemes/edit/:id",
    element: <PrivateRoute module='schemes' path="/schemes" element={<EditScheme readOnly={false} />} />,
    title: "Edit",
  },
  {
    path: "/schemes/:id",
    element: <PrivateRoute module='schemes' path="/schemes" element={<EditScheme readOnly={true} />} />,
    title: "Edit",
  },
  {
    path: "/schemes/enquiries",
    element: <PrivateRoute module='schemes' path="/schemes" element={<Enquiries />} />,
    title: "Enquiries",
  },
  {
    path: "/schemes/enquiries/:id",
    element: <PrivateRoute module='schemes' path="/schemes" element={<EnquiryDetails />} />,
    title: "Enquiry Details",
  },
  {
    path: "/schemes",
    element: <PrivateRoute module='schemes' path="/schemes" element={<Schemes />} />,
    title: "Schemes",
  },
  {
    path: "/schemes/familyEnquiries",
    element: <PrivateRoute module='schemes' path="/schemes" element={<FamilyEnquiries />} />,
    title: "Family Enquiries",
  },
  {
    path: "/schemes/familyEnquiries/:id",
    element: <PrivateRoute module='schemes' path="/schemes" element={<FamilyEnquiryDetails />} />,
    title: "Family Enquiry Details",
  },
  {
    path: "/choices/responses/",
    element: <PrivateRoute module='choices' path="/choices" element={<ChoicesResponse />} />,
    title: "Choices Response",
  },
  {
    path: "/choices/viewResponse/:id",
    element: <PrivateRoute module='choices' path="/choices" element={<ResponseDetailPage />} />,
    title: "Choices Response",
  },
  {
    path: "/choices/familyResponseDetails/:id",
    element: <PrivateRoute module='choices' path="/choices" element={<FamilyResponseDetails />} />,
    title: "Choices Response",
  },
  {
    path: "/surveys/createNewSurvey/",
    element: <PrivateRoute module='surveys' path="/surveys" element={<CreateNewChoices />} />,
    title: "Create new choices",
  },
  {
    path: "/services",
    element: <PrivateRoute module='services' path="/services" element={<Services />} />,
    title: "Services",
  },
  {
    path: "/services/serviceDetails/:id",
    element: <PrivateRoute module='services' path="/service" element={<ServiceDetails />} />,
    title: "Services",
  },
  {
    path: "/jobs",
    element: <PrivateRoute module='jobs' path="/jobs" element={<Jobs />} />,
    title: "Jobs",
  },
  {
    path: "/jobs/add",
    element: <PrivateRoute module='jobs' path="/jobs" element={<AddEditJob />} />,
    title: "Jobs",
  },
  {
    path: "/jobs/edit/:id",
    element: <PrivateRoute module='jobs' path="/jobs" element={<AddEditJob />} />,
    title: "Jobs",
  },
  {
    path: "/jobs/jobsDetails/:id",
    element: <PrivateRoute module='jobs' path="/jobs" element={<JobDetails />} />,
    title: "Jobs Listing",
  },
  {
    path: "/jobs/jobsApplicationDetails/:id",
    element: <PrivateRoute module='jobs' path="/jobs" element={<JobApplicationDetails />} />,
    title: "Jobs Listing",
  },
  {
    path: "/surveys/editSurvey/:id",
    element: <PrivateRoute module='choices' path="/choices" element={<ViewChoices editChoice={true} />} />,
    title: "Edit Choice",
  },
  {
    path: "/surveys/viewSurveys/:id",
    element: <PrivateRoute module='choices' path="/choices" element={<ViewChoices viewOnly={true} />} />,
    title: "View Choice",
  },
  {
    path: "/surveyors",
    element: <PrivateRoute module='surveyors' path="/surveyors" element={<Surveyor />} />,
    title: "Surveyor",
  },
  {
    path: "/surveyors/createNewSurveyor",
    element: <PrivateRoute module='surveyors' path="/surveyors" element={<CreateNewSurveyor />} />,
    title: "Create New Surveyor",
  },
  {
    path: "/surveyors/modifySurveyorDetails",
    element: <PrivateRoute module='surveyors' path="/surveyors" element={<CreateNewSurveyor modifyFlow={true} />} />,
    title: "Modify Surveyor details",
  },
  {
    path: "/surveyors/viewSurveyorDetails/:id",
    element: <PrivateRoute module='surveyors' path="/surveyors" element={<ViewSurveyor />} />,
    title: "View Surveyor Details",
  },
  {
    path: "/surveyors/viewSubmittedDetails/:id",
    element: <PrivateRoute module='surveyors' path="/surveyors" element={<SubmittedResponseDetails />} />,
    title: "View Surveyor Details",
  },
  {
    path: "/surveyors/viewSurveys/:id",
    element: <PrivateRoute module='surveyors' path="/surveyors" element={<SurveyorChoiceResponseList />} />,
    title: "View Surveyor Details",
  },
  {
    path: "/users",
    element: <PrivateRoute module='users' path="/users" element={<Users />} />,
    title: "Users",
  },
  {
    path: "/users/userDetails/:id",
    element: <PrivateRoute module='users' path="/users" element={<UserDetails />} />,
    title: "User Details",
  },
  {
    path: "/rewards",
    element: <PrivateRoute module='rewards' path="/rewards" element={<Rewards />} />,
    title: "Rewards",
  },
  {
    path: "/rewards/rewardsDetails/:id",
    element: <PrivateRoute module='rewards' path="/rewards" element={<RewardsDetails />} />,
    title: "Rewards Details",
  },
  {
    path: "/rewards/redemptionRequestDetails/:id",
    element: <PrivateRoute module='rewards' path="/rewards" element={<RedemptionRequestDetails />} />,
    title: "Redemption Request Details",
  },
  {
    path: file_uploads,
    element: <PrivateRoute module='reports' path="/reports" element={<FileUpload />} />,
    title: "Bulk Processing",
  },
  {
    path: create_user,
    element: <PrivateRoute module='users' path="/users" element={<CreateUser />} />,
    title: "Create User",
  },
  {
    path: `${modify_user}/:id`,
    element: <PrivateRoute module='users' path="/users" element={<ModifyUser />} />,
    title: "Modify User",
  },
  {
    path: client_mapping,
    element: <PrivateRoute module='reports' path="/reports" element={<ClientMapping />} />,
    title: "Client Mapping",
  },
  {
    path: `${client_details}/:id`,
    element: <PrivateRoute module='reports' path="/reports" element={<ClientDetails />} />,
    title: "Client Details",
  },
  {
    path: add_new_client,
    element: <PrivateRoute module='reports' path="/reports" element={<AddNewClient modifyFlow={false} />} />,
    title: "Add New Client",
  },
  {
    path: add_new_client,
    element: <PrivateRoute module='reports' path="/reports" element={<AddNewClient modifyFlow={true} />} />,
    title: "Add New Client",
  },
  {
    path: `${modify_client}/:id`,
    element: <PrivateRoute module='reports' path="/reports" element={<ModifyClient />} />,
    title: "Modify Client",
  },
  {
    path: manage_roles_and_access,
    element: <PrivateRoute module='reports' path="/reports" element={<RoleManagement />} />,
    title: 'Manage Access and Roles'
  },
  {
    path: add_roles,
    element: <PrivateRoute module='reports' path="/reports" element={<AddAdminRole modifyRole={false} />} />,
    title: 'Add Roles'
  },
  {
    path: `${modify_role}/:id`,
    element: <PrivateRoute module='reports' path="/reports" element={<AddAdminRole modifyRole={true} />} />,
    title: 'Modify Roles'
  },
  {
    path: `${view_role}/:id`,
    element: <PrivateRoute module='reports' path="/reports" element={<AddAdminRole modifyRole={false} viewRole={true} />} />,
    title: 'View Roles'
  },
  {
    path: `/notifications`,
    element: <PrivateRoute module='notifications' path="/notifications" element={<Notifications/>} />,
    title: 'View Notifications'
  },
  {
    path: `/notifications/add-notification`,
    element: <PrivateRoute module='notifications' path="/add-notifications" element={<AddNotification viewMode={false}/>} />,
    title: 'Add Notification'
  },
  {
    path: `/notifications/view-notification/:id`,
    element: <PrivateRoute module='notifications' path="/view-notification" element={<AddNotification viewMode={true}/>} />,
    title: 'View Notification'
  },
  {
    path: `/landing-page`,
    element: <PrivateRoute module='landing-page' path="/landing-page" element={<LandingPage/>} />,
    title: 'View Content Pages'
  },
  {
    path: `/landing-page/add-landing-page`,
    element: <PrivateRoute module='landing-page' path="/add-landing-page" element={<AddLandingPage viewMode={false} />} />,
    title: 'Add Content'
  },
  {
    path: `/landing-page/edit-landing-page/:id`,
    element: <PrivateRoute module='landing-page' path="/edit-landing-page" element={<EditLandingPage />} />,
    title: 'Edit Content'
  },
  {
    path: `/landing-page/view-landing-page/:id`,
    element: <PrivateRoute module='landing-page' path="/view-landing-page" element={<AddLandingPage viewMode={true} />} />,
    title: 'View Content'
  },
  {
    path: `/rules`,
    element: <PrivateRoute module='landing-page' path="/rules" element={<Rules/>} />,
    title: 'View Rules'
  },
  {
    path: `/rules/add-rule`,
    element: <PrivateRoute module='landing-page' path="/add-rule" element={<AddRule viewMode={false}/>} />,
    title: 'Add Rule'
  },
  {
    path: `/rules/edit-rule/:id`,
    element: <PrivateRoute module='landing-page' path="/edit-rule" element={<AddRule viewMode={false}/>} />,
    title: 'Edit Rule'
  },
  {
    path: `/rules/view-rule/:id`,
    element: <PrivateRoute module='landing-page' path="/view-rule" element={<AddRule viewMode={true}/>} />,
    title: 'View Rule'
  },
  {
    path: "/merchant",
    element: <VoucherRedemption />,
    title: "Voucher Redemption",
  },
  {
    path: "/merchants",
    element:<PrivateRoute module='merchants' path="/merchants" element={<Merchant/>} />,
    title: "Merchant",
  },

  {
    path: '/loading',
    element: <Loading />,
    title: 'Loading'
  },
  {
    path: "/voice-recognition",
    element: <PrivateRoute module='reports' path="/voice-recording" element={<VoiceRecording />} />,
    title: "Voice Recording",
  },
  {
    path: cms_news,
    element: <PrivateRoute module='cms' path={cms_news} element={<NewsPage />} />,
    title: "CMS News",
  },
  {
    path: cms_add_news,
    element: <PrivateRoute module='cms' path={cms_add_news} element={<AddEditNews viewMode={false} />} />,
    title: "Add News",
  },
  {
    path: `${cms_edit_news}/:id`,
    element: <PrivateRoute module='cms' path={cms_edit_news} element={<AddEditNews viewMode={false} />} />,
    title: "Edit News",
  },
  {
    path: `${cms_view_news}/:id`,
    element: <PrivateRoute module='cms' path={cms_view_news} element={<AddEditNews viewMode={true} />} />,
    title: "View News",
  },
  {
    path: hospitals,
    element: <PrivateRoute module='hospitals' path={hospitals} element={<HospitalsPage />} />,
    title: "Ayushman Bharat Hospitals",
  },
  {
    path: hospitals_add,
    element: <PrivateRoute module='hospitals' path={hospitals_add} element={<AddEditHospital viewMode={false} />} />,
    title: "Add Hospital",
  },
  {
    path: `${hospitals_edit}/:id`,
    element: <PrivateRoute module='hospitals' path={hospitals_edit} element={<AddEditHospital viewMode={false} />} />,
    title: "Edit Hospital",
  },
  {
    path: `${hospitals_view}/:id`,
    element: <PrivateRoute module='hospitals' path={hospitals_view} element={<AddEditHospital viewMode={true} />} />,
    title: "View Hospital",
  },
  {
    path: hospital_schemes,
    element: <PrivateRoute module='hospitals' path={hospital_schemes} element={<HospitalSchemesPage />} />,
    title: "Hospital Schemes",
  },
  {
    path: hospital_facilities,
    element: <PrivateRoute module='hospitals' path={hospital_facilities} element={<HospitalFacilitiesPage />} />,
    title: "Hospital Facilities",
  },
  {
    path: hospital_specialities,
    element: <PrivateRoute module='hospitals' path={hospital_specialities} element={<HospitalSpecialitiesPage />} />,
    title: "Hospital Specialities",
  },
  {
    path: organizations,
    element: <PrivateRoute module='organizations' platformOnly path={organizations} element={<OrganizationsPage />} />,
    title: "Organisations",
  },
  {
    path: organizations_add,
    element: <PrivateRoute module='organizations' platformOnly path={organizations_add} element={<AddEditOrganization />} />,
    title: "Add Organisation",
  },
  {
    path: `${organizations_edit}/:id`,
    element: <PrivateRoute module='organizations' platformOnly path={organizations_edit} element={<AddEditOrganization />} />,
    title: "Edit Organisation",
  },
  {
    path: cms_banners,
    element: <PrivateRoute module='cms' path={cms_banners} element={<BannersPage />} />,
    title: "CMS Banners",
  },
  {
    path: cms_add_banner,
    element: <PrivateRoute module='cms' path={cms_add_banner} element={<AddEditBanner viewMode={false} />} />,
    title: "Add Banner",
  },
  {
    path: `${cms_edit_banner}/:id`,
    element: <PrivateRoute module='cms' path={cms_edit_banner} element={<AddEditBanner viewMode={false} />} />,
    title: "Edit Banner",
  },
  {
    path: `${cms_view_banner}/:id`,
    element: <PrivateRoute module='cms' path={cms_view_banner} element={<AddEditBanner viewMode={true} />} />,
    title: "View Banner",
  },
  {
    path: cms_media,
    element: <PrivateRoute module='cms' path={cms_media} element={<MediaLibrary />} />,
    title: "CMS Media",
  },
  {
    path: cms_amiforyou,
    element: <PrivateRoute module='cms' path={cms_amiforyou} element={<AmiForYouPage />} />,
    title: "CMS AMI For You",
  },
  {
    path: cms_add_amiforyou,
    element: <PrivateRoute module='cms' path={cms_add_amiforyou} element={<AddEditAmiForYou viewMode={false} />} />,
    title: "Add AMI For You",
  },
  {
    path: `${cms_edit_amiforyou}/:id`,
    element: <PrivateRoute module='cms' path={cms_edit_amiforyou} element={<AddEditAmiForYou viewMode={false} />} />,
    title: "Edit AMI For You",
  },
  {
    path: `${cms_view_amiforyou}/:id`,
    element: <PrivateRoute module='cms' path={cms_view_amiforyou} element={<AddEditAmiForYou viewMode={true} />} />,
    title: "View AMI For You",
  },
  {
    path: cms_app_polling,
    element: <PrivateRoute module='cms' path={cms_app_polling} element={<AppPollingPage />} />,
    title: "CMS App Polling",
  },
  {
    path: cms_add_app_polling,
    element: <PrivateRoute module='cms' path={cms_add_app_polling} element={<AddEditAppPolling viewMode={false} />} />,
    title: "Add App Polling",
  },
  {
    path: `${cms_edit_app_polling}/:id`,
    element: <PrivateRoute module='cms' path={cms_edit_app_polling} element={<AddEditAppPolling viewMode={false} />} />,
    title: "Edit App Polling",
  },
  {
    path: `${cms_view_app_polling}/:id`,
    element: <PrivateRoute module='cms' path={cms_view_app_polling} element={<AddEditAppPolling viewMode={true} />} />,
    title: "View App Polling",
  },

];

export default createBrowserRouter(routes);
